import request from "@/utils/request";
import Qs from "qs";


// 能耗导入记录
export function energy_import_lists(data) {
  return request({
    url: "/energy/import_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗导入删除
export function energy_import_del(data) {
  return request({
    url: "/energy/import_del",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 预览账单
export function bill_review(data) {
  return request({
    url: "/energy/bill_review",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看账单
export function bill_review_url(data) {
  return request({
    url: "/energy/bill_review_url",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 下载账单
export function bill_download(data) {
  return request({
    url: "/energy/bill_download",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 下载能耗表
export function download_table(data) {
  return request({
    url: "/energy/download_table",
    method: "post",
    data: Qs.stringify(data)
  });
}


// 批量下载账单
export function batch_bill_download(data) {
  return request({
    url: "/energy/batch_bill_download",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}

// 发送账单
export function send_bill(data) {
  return request({
    url: "/energy/send_bill",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 下载原始导入的能耗表
export function download_primitive_table(data) {
  return request({
    url: "/energy/download_primitive_table",
    method: "post",
    data: Qs.stringify(data)
  });
}



// 老数据

// 获取能耗列表-公共接口
export function get_energy_lists(data) {
  return request({
    url: "/common/get_energy_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 能耗设备导入模板下载
export function import_enery_template(data) {
  return request({
    url: "/energy/import_template",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 远程抄表，生成记录
export function add_remote_record(data) {
  return request({
    url: "/energy/add_remote_record",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 设置能耗配置
export function setConfig(data) {
  return request({
    url: "/energy/set_config",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 获取能耗配置
export function getConfig(data) {
  return request({
    url: "/energy/get_config",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗硬件用度统计
export function getStatistics(data) {
  return request({
    url: "/energy/statistics",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 能耗列表
export function energyList(data) {
  return request({
    url: "/energy/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看能耗
export function energyInfo(data) {
  return request({
    url: "/energy/info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加能耗
export function energyAdd(data) {
  return request({
    url: "/energy/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑能耗
export function energyEdit(data) {
  return request({
    url: "/energy/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除能耗
export function energyDel(data) {
  return request({
    url: "/energy/del",
    method: "post",
    data: Qs.stringify(data),
  });
}




// 能耗模板列表
export function taskLists(data) {
  return request({
    url: "/energy/task_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看能耗模板
export function energyTaskInfo(data) {
  return request({
    url: "/energy/task_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加能耗模板
export function energyTaskAdd(data) {
  return request({
    url: "/energy/task_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑能耗模板
export function energyTaskEdit(data) {
  return request({
    url: "/energy/task_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除能耗模板
export function energyTaskDel(data) {
  return request({
    url: "/energy/task_del",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 能耗记录列表
export function recordLists(data) {
  return request({
    url: "/energy/record_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗记录详情
export function recordInfo(data) {
  return request({
    url: "/energy/record_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑能耗记录
export function recordEdit(data) {
  return request({
    url: "/energy/record_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 删除能耗记录
export function recordDel(data) {
  return request({
    url: "/energy/record_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗记录确认
export function recordAffirm(data) {
  return request({
    url: "/energy/record_affirm",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 能耗账单列表
export function orderLists(data) {
  return request({
    url: "/energy/order_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗账单详情
export function orderInfo(data) {
  return request({
    url: "/energy/order_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗账单状态操作
export function orderChange(data) {
  return request({
    url: "/energy/order_change",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 能耗任务列表
export function taskDayLists(data) {
  return request({
    url: "/energy/task_day_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗任务详情
export function taskDayInfo(data) {
  return request({
    url: "/energy/task_day_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 能耗任务关闭
export function taskDayClose(data) {
  return request({
    url: "/energy/task_day_close",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 能耗任务进度
export function taskDayProgress(data) {
  return request({
    url: "/energy/task_day_progress",
    method: "post",
    data: Qs.stringify(data),
  });
}
